import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
  parent: {
    backgroundColor: "#F5F8FF",
  },
  bodyContainer: {
    padding: "20px 20px 20px 300px",
    minHeight: "100%",
  },
  inputSectionParent: {
    marginTop: "75px",
    display: "flex",
    alignItems: "center",
  },
  patients: {
    marginLeft: "10px",
  },
  addColor: {
    color: "#012497",
  },
  saveBtnbox: {
    textAlign: "right",
    paddingRight: "18px",
  },
  saveBtn: {
    background: "#3D63E6",
    padding: "10px 35px",
    border: "none",
    color: "#fff",
    marginBottom: "10px",
    marginTop: "10px",
    borderRadius: "3px",
    width: "160px",
    height: "50px",
    fontFamily: "Cairo",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "30px",
  },
  messageModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    width: "907px",
    height: "380px",
    backgroundColor: "#F5F8FF",
  },
  modalContainer: {
    padding: "10px 30px 20px 30px",
    height: "380px",
  },
  treatment_heading: {
    textAlign: "center",
    fontFamily: "Cairo",
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "24px",
    lineHeight: "110%",
    color: "#508D9B",
  },
  modal_table: {
    width: "847px",
    border: "1px solid lightgrey",
  },
  modal_table_header: {
    padding: "10px",
    fontFamily: "Cairo",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "30px",
    color: "#2A3333",
  },
  modal_table_category: {
    padding: "6px 12px",
    backgroundColor: "#FFFFFF",
    fontFamily: "Cairo",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "30px",
    color: "#2A3333",
  },
  btnContainer: {
    display: "flex",
    alignItems: "flex-end",
  },
  cancelBtn: {
    color: "#3D63E6",
    borderColor: "#3D63E6",
    "&:hover": {
      borderColor: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  label1: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "16px",
    color: "#2A3333",
    lineHeight: "24px",
  },
  modal_dropDown: {
    marginLeft: "5px",
  },
  deletePatientBtn: {
    color: "#FF4839",
    borderColor: "#FF4839",
    "&:hover": {
      borderColor: "#FF4839",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "190px",
    height: "50px",
    borderRadius: 4,
  },
  dataTableDiv: {
    maxHeight: "calc(100vh - 310px)",
    maxWidth: "calc(159vh)",
    border: "1px solid #C6C9CA",
    overflowY: "auto",
    overflowX: "auto",
    marginTop: "0px",
    background: "#F5F8FF",
  },
  deleteModal: {
    position: "absolute",
    background: "#FFFFFF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    width: "410px",
    height: "230px",
  },
  headerModal: {
    color: "#012497",
    fontFamily: "Cairo",
    fontWeight: "800",
    fontSize: "24px",
  },
  deleteTypo: {
    color: "#2A3333",
    fontFamily: "Cairo",
    fontWeight: "400",
    fontSize: "16px",
  },
}));
